import { getActiveTenancy, setActiveTenancy, setActiveTenancyIdentity } from "./storage";
import { requestTenancySelection } from "./recovery";

export type TenancyGroup = { id: string; name?: string };

export type TenancyResolution = "forced" | "preserved" | "selected-only-tenancy" | "selection-required";

/**
 * Reconciles authentication claims without using them to invalidate an existing
 * tab selection. Refreshed group claims can be partial, reordered, or empty.
 */
export const reconcileActiveTenancy = (
  groups: TenancyGroup[] | null | undefined,
  forcedTenancy?: string | null,
  identity?: string | null,
): TenancyResolution => {
  if (!identity || !setActiveTenancyIdentity(identity)) {
    requestTenancySelection();
    return "selection-required";
  }

  if (forcedTenancy) {
    if (!setActiveTenancy(forcedTenancy)) {
      requestTenancySelection();
      return "selection-required";
    }
    return "forced";
  }

  if (getActiveTenancy()) {
    return "preserved";
  }

  const availableTenancies = groups ?? [];
  if (availableTenancies.length === 1 && setActiveTenancy(availableTenancies[0].id)) {
    return "selected-only-tenancy";
  }

  requestTenancySelection();
  return "selection-required";
};
